class SignupCommon {
  constructor($timeout) {
    this.$timeout = $timeout;
  }

  setLoader() {
    this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    console.log("We have UNSET the loader in the common service");
    this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  showTOS() {
    this.$timeout(() => {
      $("#terms-of-service").modal();
    });
  }

  closeTerms() {
    this.$timeout(() => {
      $("#terms-of-service").modal("toggle");
    });
  }

  removeBodyClass() {
    this.$timeout(() => {
      // $('body').removeClass().addClass('signup-bg');
    });
  }

  closeVerificationModal() {
    this.$timeout(() => {
      $("#verification-modal .modal-header button.close").trigger("click");
      $(".modal-backdrop").remove();
      this.removeBodyClass();
    }, 10);

    this.$timeout(() => {
      // $('body').removeClass('signup-bg');
    }, 200);
  }
}

SignupCommon.$inject = ["$timeout"];

export default SignupCommon;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/services/common.js